import { IBooleanMetric, InteractionMetric } from "@edgetier/watchtower-types";

/**
 * Check if a given metric is a boolean metric.
 * @param metric Interaction metric.
 * @returns True if the metric is a boolean metric, false otherwise.
 */
export const isBooleanMetric = (metric: InteractionMetric): metric is IBooleanMetric => {
    if (metric === InteractionMetric.QueryResolution) {
        return true;
    }
    return false;
};
